import React from 'react';
import { Container, Menu, Image, Dropdown} from 'semantic-ui-react';
import { Link } from 'react-router-dom';
import { useAuth0 } from '@auth0/auth0-react';

export const NavBar = () => {

  const { isAuthenticated, loginWithRedirect, logout, user} = useAuth0();
  let authState;
  let searchState

// This showcases the profile

  if (!isAuthenticated) {
    authState = (<Menu.Item href='#' onClick={() => loginWithRedirect({})}>Log In</Menu.Item>);
  } else {
    authState = (
      <Dropdown
        item
        trigger={<Image src={user.picture} avatar />}
        direction="left" 
      >
        <Dropdown.Menu>
          <Dropdown.Item as={Link} to="/profile">
            <Image src={user.picture} avatar />
            {user.name}
          </Dropdown.Item>
          <Dropdown.Divider />
          <Dropdown.Item
            onClick={() => logout({ returnTo: window.location.origin })}
          >
            Log Out
          </Dropdown.Item>
        </Dropdown.Menu>
      </Dropdown>
  )
  }


  searchState=( <Menu.Item as={Link} to='/search'>Search</Menu.Item> )


  return (
    <Container id="nav-top" fluid>
      <Container>
        <Menu fluid secondary inverted widths={5}>
          <Menu.Item as={Link} to='/partnership'>NATS Partnership</Menu.Item>
          <Menu.Item as={Link} to='/about'>About the Project</Menu.Item>
          <Menu.Item className='logo' as={Link} to='/'>
            <Image src='/img/living-song-project.png' fluid />
          </Menu.Item>
          {searchState}
          {authState}
        </Menu>
      </Container>
    </Container>
  );
}
